import React, { forwardRef } from 'react';

import { StyledInput } from './Input.styles';
import type { InputProps } from './Input.types';

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ variant = 'outlined', error, ...rest }, ref) => (
    <StyledInput
      ref={ref}
      $variant={variant}
      $error={error}
      aria-invalid={error || undefined}
      {...rest}
    />
  )
);

Input.displayName = 'Input';
